import { authClient, API } from "../index";

export const getPlansAdmin = () => authClient().get(`${API}/plan`);

export const createPlan = (plan) => authClient().post(`${API}/plan`, plan);

export const updatePlan = (id, plan) => authClient().put(`${API}/plan/${encodeURIComponent(id)}`, plan);

export const deletePlan = (id) => authClient().delete(`${API}/plan/${encodeURIComponent(id)}`);

export const getPlanFeatureCatalog = () => authClient().get(`${API}/plan/feature-catalog`);

